import loadable from '@loadable/component';

export default loadable(
  () =>
    import(
      /* webpackChunkName: "__support-contact" */
      './SupportContactMain'
    ),
);
